import React from 'react'
import { HiTrash } from 'react-icons/hi'
import { Spinner } from 'flowbite-react'

const TrashIconButton = ({
  onClick,
  disabled = false,
  loading = false,
  label,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || loading}
    aria-label={label}
    title={label}
    className="inline-flex items-center justify-center rounded-lg p-2 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-red-900/30 dark:hover:text-red-400"
  >
    {loading ? <Spinner size="sm" /> : <HiTrash className="h-4 w-4" />}
  </button>
)

export default TrashIconButton
